import { ExpandableContent, RichText } from '@jeromevvb/equinox-lib'
import RichTextBlock from '@models/projects/interfaces/richText.interface'

interface FaqProps {
  faqs: {
    question: string
    answer: RichTextBlock
  }[]
}

const Faq = ({ faqs }: FaqProps) => {
  return (
    <div>
      {faqs.map(({ answer, question }, key) => (
        <div key={key}>
          {answer && (
            <ExpandableContent label={question}>
              <RichText
                json={answer?.json}
                links={answer?.links}
                className="mb-8"
              />
            </ExpandableContent>
          )}
        </div>
      ))}
    </div>
  )
}

export default Faq
